/**
 * Shared PSR (Priority Services Register) helpers.
 *
 * The vulnerable-customer rule lives here so it stays identical across the
 * backend job-list query and any other consumer (WRK-5510).
 */
import type { Psr } from './work-orders/workOrderImport.contract';

/**
 * A job is flagged as serving a vulnerable customer when the PSR block reports
 * `fieldIdentified` or `iid` as true. Any other shape (null, missing flags)
 * is not vulnerable.
 */
export function isVulnerablePsr(psr: Psr | null | undefined): boolean {
  if (!psr) return false;
  return psr.fieldIdentified === true || psr.iid === true;
}
